import type { SupportRequestFields } from "@go-novus/admin-api";
import type { WidgetContactRequestType } from "./contact-card";

export const requestTypes: Record<
  SupportRequestFields["request_type"],
  WidgetContactRequestType
> = {
  order_status_tracking: "order_status",
  order_cancellation: "order_cancellation",
  order_changes: "order_changes",
  delivery_issues: "delivery_issues",
  returns_exchanges_refunds: "returns",
  product_issues_warranty: "product_issues",
  product_subscriptions: "subscriptions",
  other_contact_support: "other",
};
